import { render, staticRenderFns } from "./coding-queries.vue?vue&type=template&id=927d94d2"
import script from "./coding-queries.vue?vue&type=script&lang=js"
export * from "./coding-queries.vue?vue&type=script&lang=js"
import style0 from "./coding-queries.vue?vue&type=style&index=0&id=927d94d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports